{
  "el": {
    "ticket": {
      "actions": {
        "assignCustomer": "Ολοκλήρωση διαδικασίας",
        "bulk_assign_new_emp": "Μαζική ανάθεση νέου υπευθύνου",
        "close": "Κλείσιμο",
        "create_new": "Δημιουργία νέας συνομιλίας",
        "customer_new_ticket": "Νέα συνομιλία",
        "delete": "Διαγραφή",
        "edit": "Επεξεργασία",
        "existing_conversation": "Υπάρχουσα συνομιλία",
        "goToConversation": "Μετάβαση στη συνομιλία",
        "move_to_existing": "Μετακίνηση μηνύματος σε υπάρχουσα συνομιλία",
        "new": "Συνομιλία",
        "new_aria_label": "Έναρξη νέας συνομιλίας",
        "new_conversation": "Νέα συνομιλία",
        "reopen": "Άνοιγμα ξανά",
        "selectResponsible": "Επιλογή υπευθύνου",
        "selectUnit": "Επιλογή ακινήτου",
        "show": "Εμφάνιση",
        "startNew": "Έναρξη νέας συνομιλίας"
      },
      "attributes": {
        "status": "Κατάσταση",
        "statuses": {
          "closed": "Κλειστή",
          "feedback": "Σε αναμονή απάντησης",
          "ongoing": "Σε εξέλιξη",
          "open": "Ανοιχτή"
        },
        "title": "Τίτλος"
      },
      "editor": {
        "tooltips": {
          "bold": "Έντονα",
          "bulletList": "Λίστα με κουκκίδες",
          "highlight": "Επισήμανση",
          "italic": "Πλάγια",
          "link": "Σύνδεσμος",
          "orderedList": "Αριθμημένη λίστα",
          "redo": "Επανάληψη",
          "strike": "Διακριτή διαγραφή",
          "textColor": "Χρώμα κειμένου",
          "underline": "Υπογράμμιση",
          "undo": "Αναίρεση",
          "unlink": "Κατάργηση συνδέσμου"
        }
      },
      "labels": {
        "additionalQuestion": "Έχεις κάποια επιπλέον ερώτηση;",
        "all": "Όλες",
        "allProjects": "Όλα τα έργα",
        "allUnits": "Όλα τα ακίνητα",
        "assign_conversations": "Ανάθεση συνομιλιών από",
        "bulk_assign_new_emp_warning": "Αυτή η ενημέρωση θα περιλάβει και τις συνομιλίες που συνδέονται με αποφάσεις ή με παρατηρήσεις. Για τις σχετικές αποφάσεις (αυτών των συνομιλιών) θα ενημερωθεί επίσης ο υπεύθυνος υπάλληλος.",
        "cantChangeResponsibleAftercare": "Αυτή η συνομιλία συνδέεται με μια παρατήρηση. Άλλαξε τον υπεύθυνο εκεί.",
        "cantChangeResponsibleDecision": "Αυτή η συνομιλία συνδέεται με μια απόφαση. Άλλαξε τον υπεύθυνο εκεί.",
        "cantDelete": "Αυτή η συνομιλία ανήκει σε μια απόφαση και δεν μπορεί να διαγραφεί.",
        "cantEdit": "Αυτή η συνομιλία ανήκει σε μια απόφαση. Επεξεργάσου την από την απόφαση",
        "changeResponsible": "Τροποποίηση",
        "change_responsible": "Αλλαγή υπευθύνου συνομιλιών",
        "clientWillRespondSoon": "Θα επικοινωνήσουμε μαζί σου το συντομότερο δυνατό",
        "contact": "Επαφή",
        "contactPerson": "Η επαφή σου",
        "contactPersonWithName": "Η επαφή σου για {name}",
        "conversation_title": "Τίτλος συνομιλίας",
        "conversations": "Συνομιλίες",
        "create_ticket": "Δημιουργία συνομιλίας",
        "customer": "Πελάτης",
        "customers": "Πελάτες",
        "decision": "Ποια απόφαση;",
        "decisionConversation": "Απόφαση",
        "decisionConversations": "Αποφάσεις",
        "disabled_unit": "Αυτό το ακίνητο έχει απενεργοποιηθεί. Δεν μπορούν να σταλούν μηνύματα.",
        "documentAddedBy": "από",
        "documents": "Έγγραφα",
        "email_forwarding": "Προώθηση email",
        "employee": "Υπάλληλος",
        "export_conversation": "Εξαγωγή συνομιλίας",
        "files": "Αρχεία",
        "filter": "Φίλτρο",
        "inbound_by": "Εισερχόμενο από {name}",
        "inbound_emails": "Εισερχόμενα email",
        "info": "Έχεις μια ερώτηση και δεν βρήκες την απάντηση στην ενότητα {faq_route}; Ρώτησέ τη εδώ. Προσπάθησε να ομαδοποιείς τις ερωτήσεις σου σε ξεκάθαρα θέματα συνομιλίας, π.χ. «Προδιαγραφές». ",
        "keywords": "Αναζήτηση περιεχομένου",
        "lastMessage": "Τελευταίο μήνυμα",
        "message": "Μήνυμα",
        "message_placeholder": "Γράψε εδώ το μήνυμά σου...",
        "message_subtitle": "Περίγραψε την ερώτηση ή το πρόβλημά σου",
        "messaged_at_nulls_first_asc": "Παλαιότερη δραστηριότητα",
        "messaged_at_nulls_last_desc": "Τελευταία δραστηριότητα",
        "myProjects": "Τα έργα μου",
        "myTickets": "Οι συνομιλίες μου",
        "myTicketsTooltip": "Εμφάνιση μόνο των συνομιλιών που σου έχουν ανατεθεί",
        "name_lower_asc": "Τίτλος Α → Ω",
        "name_lower_desc": "Τίτλος Ω → Α",
        "newConversation": "Νέα συνομιλία",
        "newMessage": "Νέο μήνυμα",
        "newMessages": "Νέα μηνύματα",
        "newWithPartner": "Ziggu και {partner}",
        "newWithZiggu": "Μόνο Ziggu",
        "noCustomer": "Δεν έχει ανατεθεί ούτε προσκληθεί ακόμη πελάτης",
        "noCustomerAssignedToUnit": "Δεν έχει ανατεθεί πελάτης σε αυτό το ακίνητο. Θέλεις να συνεχίσεις;",
        "noCustomerAssignedToUnitExplainer": "Σημείωσε ότι θα πρέπει να επιλέξεις άλλον παραλήπτη.",
        "noCustomerAssignedToUnit_SUP": "Δεν έχει ανατεθεί πελάτης σε αυτό το έργο. Θέλεις να συνεχίσεις;",
        "noCustomerInvited": "Ο πελάτης που έχει ανατεθεί σε αυτό το ακίνητο δεν έχει προσκληθεί ακόμη. Θέλεις να συνεχίσεις;",
        "noFiles": "Δεν έχουν ανέβει ακόμη αρχεία",
        "noMessagesYet": "Δεν υπάρχουν ακόμη μηνύματα",
        "noTickets": "Καμία συνομιλία",
        "no_messages": "Η συνομιλία δεν έχει μηνύματα",
        "notSeenYet": "Δεν το έχει δει ακόμη",
        "notYetDetermined": "Δεν έχει καθοριστεί ακόμη",
        "note": "Σημείωση",
        "note_placeholder": "Γράψε μόνο στα μέλη της ομάδας. Πληκτρολόγησε {'@'} για να αναφέρεις ένα μέλος της ομάδας και θα ειδοποιηθεί.",
        "onlySelect": "Εμφάνιση μόνο",
        "orNewTicket": "Ή άνοιξε μια νέα για διαφορετικό θέμα",
        "otherTickets": "Άλλες συνομιλίες πελάτη",
        "participants": "1 συμμετέχων | {count} συμμετέχοντες",
        "partner": "Συνεργάτης",
        "partnerGroup": "Με ποιον θέλεις να μιλήσεις;",
        "partnersDecision": "Συνεργάτες απόφασης",
        "pendingContactPerson": "Η επαφή σου θα απαντήσει το συντομότερο δυνατό",
        "pendingTickets": "Νέα μηνύματα",
        "project": "Έργο",
        "read": "Αναγνωσμένες",
        "remove_inbound_email": "Αφαίρεση {email};",
        "reply": "Απάντηση",
        "reply_placeholder": "Γράψε σε όλους",
        "responsible": "Υπεύθυνος",
        "search": "Αναζήτηση",
        "search_conversation": "Αναζήτηση",
        "seen": "Το είδαν",
        "seenAll": "όλοι",
        "seenBy": "Το είδε {name}",
        "selectLevel": "Επιλογή επιπέδου",
        "selectUnit": "Επιλογή ακινήτου",
        "show": "Εμφάνιση",
        "showFiles": "Εμφάνιση αρχείων",
        "showTicketsFor": "Εμφάνιση συνομιλιών για",
        "showingAll": "Όλες οι συνομιλίες",
        "sort": "Ταξινόμηση κατά",
        "startConversation": "Έναρξη νέας συνομιλίας",
        "startConversationForProject": "Έναρξη νέας συνομιλίας στο έργο ",
        "startNewConversation": "Έναρξη νέας συνομιλίας",
        "subject": "Θέμα",
        "subject_subtitle": "Περίγραψε με λίγα λόγια",
        "teamMember": "Μέλος ομάδας",
        "ticketClosed": "Αυτή η συνομιλία έχει κλείσει.",
        "ticketClosedByResponsible": "Αυτή η συνομιλία έκλεισε από {responsible}",
        "ticketClosedCustomer": "Αν έχεις άλλη ερώτηση, άνοιξε μια νέα συνομιλία.",
        "ticketClosedEmployee": "Αν θέλεις να ανοίξεις ξανά τη συνομιλία, άλλαξε την κατάσταση παραπάνω.",
        "ticket_category": "Κατηγορία",
        "tickets_all_projects": "Συνομιλίες όλων των έργων",
        "to": "σε",
        "unit": "Ακίνητο",
        "unit_name_lower_asc": "Ακίνητο Α → Ω",
        "unit_name_lower_desc": "Ακίνητο Ω → Α",
        "unread": "Μη αναγνωσμένες",
        "upload_files": "1 αρχείο σε εκκρεμότητα | {count} αρχεία σε εκκρεμότητα",
        "warning_move_message_to_new_ticket": "Αυτό το μήνυμα θα μετακινηθεί σε μια κανονική συνομιλία, η οποία δεν θα συνδέεται με απόφαση ή παρατήρηση.",
        "withMentions": "Με αναφορά σε σένα",
        "withMessages": "Με μηνύματα",
        "writeMessageToBecomeResponsible": "Γράψε ένα μήνυμα για να αναλάβεις την ευθύνη",
        "you": "Εσύ"
      },
      "messages": {
        "redirect_decision": "Αυτή η συνομιλία είναι μέρος μιας απόφασης. Κάνε κλικ εδώ για να δεις την απόφαση.",
        "redirect_issue": "Αυτή η συνομιλία είναι μέρος των Παρατηρήσεων. Κάνε κλικ εδώ για να μεταβείς στις Παρατηρήσεις.",
        "redirect_link": "Δες λεπτομέρειες"
      },
      "navigation": {
        "backToTickets": "Επιστροφή"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Προσπάθησε να ομαδοποιείς τις ερωτήσεις σου σε γενικά θέματα συνομιλίας, π.χ. «Προδιαγραφές».",
            "title": "Έχεις μια ερώτηση; Ρώτησέ τη εδώ."
          },
          "none": {
            "title": "Δεν βρέθηκαν συνομιλίες"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Ξεκίνα την πρώτη σου συνομιλία με κάποιον.",
            "title": "Θέλεις να ρωτήσεις κάτι;"
          },
          "none": {
            "subtitle": "Προσάρμοσε τα φίλτρα στο πάνω μέρος της σελίδας ή ξεκίνα να παρακολουθείς ένα έργο για να βρεις τις σχετικές συνομιλίες",
            "subtitle_aftercare": "Κάνε κλικ στις 3 τελείες μιας παρατήρησης για να ξεκινήσεις συνομιλία",
            "title": "Δεν βρέθηκαν συνομιλίες"
          }
        }
      },
      "toasts": {
        "responsible_updated": "Ο υπεύθυνος ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "mustBeMaximum": "Το θέμα πρέπει να είναι κάτω από {number} χαρακτήρες.",
        "needCustomer": "Επίλεξε έναν πελάτη",
        "needMessage": "Το μήνυμα είναι υποχρεωτικό",
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "needResponsible": "Επίλεξε έναν υπεύθυνο",
        "needSubject": "Το θέμα είναι υποχρεωτικό",
        "needUnit": "Επίλεξε ένα ακίνητο"
      }
    }
  }
}
